var DATAVIEW_CSS_GRID_TEMPLATE_COLUMNS = "repeat(auto-fill, minmax(19rem, 1fr))";

export { DATAVIEW_CSS_GRID_TEMPLATE_COLUMNS };
//# sourceMappingURL=utils.js.map
